import Input from "./InputComponent";

export default Input;
